import { createWebBackApi } from '../../api/webBackApi';

const webBackApi = createWebBackApi();

export const getSidebarConfig = async (customerId) => {
  try {
    const response = await webBackApi.get(`/api/sidebar-config/${customerId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching sidebar config for customer ${customerId}:`, error);
    throw error;
  }
};
